export default __webpack_public_path__ + "static/media/eyevisible.89535677.svg";